import React from 'react';
import Breadcrumb from '../Components/Breadcrumb';
import {data} from '../Data/GoldCoinData'
// 'blue':"#244D91",
    //   "yellow":"#A69145"
const Goldcoin = () => {
  return (
    <main className=' w-[90%] mx-auto'>
      <Breadcrumb/>
      <div className='py-4'>
        <div className='text-center border-b border-b-gray-400 pb-6 '>
          <h2 className='capitalize text-[#244D91]'>Buy gold coins online</h2>
          <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Asperiores unde fugiat iusto eveniet porro vitae rerum ea id iure labore.</p>
        </div>
        <div className='py-[2rem] grid gap-[2rem] sm:grid-cols-2 lg:grid-cols-3  sm:justify-between items-center w-full my-6'>
          {data.map(coin=>{
            return (
              <div key={coin.id} className='w-[100%] shadow-md mx-auto flex flex-col items-center justify-around rounded-md bg-white h-[23rem]'>
                <div className='grid justify-center items-center w-full h-[15rem]'>
                  <img src={coin.image} alt={coin.title} className='w-[10rem] h-[15rem] mx-auto object-contain'/>
                </div>
                  <div className='border-t border-t-gray-400 w-full px-6 py-4 h-[8rem] flex flex-col justify-between'>
                    <h5>{coin.heading}</h5>
                    <div className='flex justify-between items-center'>
                        <p>$110.00</p>
                        <button className='bg-blue py-2 bg-[#A69145] text-white rounded-md px-4'>Buy Now</button>
                  </div>
                </div>
            </div>
            )
          })}
        </div>
      </div>
    </main>
  )
}

export default Goldcoin